import { render } from "./ContainerNode.vue?vue&type=template&id=63515f26&scoped=true"
import script from "./ContainerNode.vue?vue&type=script&lang=js"
export * from "./ContainerNode.vue?vue&type=script&lang=js"

import "./ContainerNode.vue?vue&type=style&index=0&id=63515f26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63515f26"]])

export default __exports__